<script>
import LazyComponentMixin from '~/mixins/LazyComponentMixin'

export default {
  mixins: [LazyComponentMixin],
  data() {
    return {
      wrapperClass: 'GoogleMapLazy',
      componentFactory: () => import('./GoogleMap.vue'),
    }
  },
}
</script>

<style lang="scss">
@import '~variables';

.GoogleMapLazy {
  display: flex;
}

.GoogleMapLazy > .vue-map-container {
  flex-grow: 1;
}

.GoogleMapLazy > .PlaceholderBox {
  @include media-breakpoint-up(lg) {
    min-height: 480px;
  }

  @include media-breakpoint-up(xl) {
    min-height: 400px;
  }
}
</style>
